module.exports = __webpack_public_path__ + "static/media/person.f9a567b0.svg";